import React from 'react';
import { Rate } from 'antd';

import WidgetComponent from '../../widget/WidgetComponent';
import '../../css/common.css';

class NewEnt extends WidgetComponent
{
    constructor(props)
    {
        super(props);
        this.state = {
           
        };
 
    }

    componentDidUpdate( )
    {
        
    }

    render() 
	{
        const {options, columns, params } = this.state;
        
        return( 
            <div className="common-all">
                <div className='common-box'>
                    <div>
                        <div className='common-top' id ={"score_id"} >
                            <div className="img">
                            <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                            </div>
                            <div className='common-survival'>推荐指数</div>
                        </div>
                        <div className='common-echarts-all' style={{height:'auto'}}>
                            <Rate disabled defaultValue={2} />
                        </div>
                    </div>
                    <div>
                        <div className='common-top' id ={"explain_id"} >
                            <div className="img">
                            <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                            </div>
                            <div className='common-survival'>推荐说明</div>
                        </div>
                        <div className='common-echarts-all' style={{height:'500px',textAlign:'left'}}>
                            <span>新推荐度用于表征基于新企法人、高管对外投资情况（包括但不限于董监高对外投资企业数、董监高对外投资企业吊销数、董监高对外投资企业注册资本总和、董监高对外投资企业实际缴纳资本总和、董监高对外投资企业失信被执行人次数、董监高对外投资企业行政处罚次数等）自身所处行业竞争程度评价、对客户讨价还价能力评分数据所体现出的新企综合评价推荐指数。</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

export default NewEnt